import { render, staticRenderFns } from "./POIHikingState.vue?vue&type=template&id=38708aad"
import script from "./POIHikingState.js?vue&type=script&lang=js&external"
export * from "./POIHikingState.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports